import { CheckCircle2, Circle, MinusCircle } from "lucide-react";
import { Panel } from "@/components/admin/ui";

export default function OrgChecklistTab({ requirements, org, onActivate, activating }) {
  return (
    <div className="space-y-6" data-testid="org-checklist-tab">
      <Panel title="Activation Checklist" subtitle={`${requirements.completed_count} of ${requirements.total_count} requirements complete`}>
        <div className="mb-5 h-3 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-white/10">
          <div
            className="h-full rounded-full bg-gradient-to-r from-[#0052FF] to-[#00D4FF] transition-all duration-500"
            style={{ width: `${requirements.percent}%` }}
            data-testid="org-checklist-progress-bar"
          />
        </div>
        <div className="space-y-2" data-testid="org-checklist-items">
          {requirements.items.map((item) => (
            <div key={item.key} className="flex items-center gap-3 rounded-xl border border-slate-200 p-3 dark:border-white/10" data-testid={`org-checklist-item-${item.key}`}>
              {!item.applicable ? (
                <MinusCircle size={18} className="shrink-0 text-slate-300 dark:text-slate-600" />
              ) : item.complete ? (
                <CheckCircle2 size={18} className="shrink-0 text-emerald-500" />
              ) : (
                <Circle size={18} className="shrink-0 text-slate-300 dark:text-slate-600" />
              )}
              <span className={`text-sm font-semibold ${item.applicable ? "text-slate-900 dark:text-white" : "text-slate-400 dark:text-slate-600"}`}>{item.label}</span>
              {!item.applicable && <span className="ml-auto text-xs font-bold uppercase tracking-wide text-slate-400 dark:text-slate-600">Not applicable</span>}
            </div>
          ))}
        </div>
      </Panel>

      <Panel title="Activation">
        {org.status !== "Onboarding" ? (
          <p className="text-sm font-semibold text-slate-600 dark:text-slate-400" data-testid="org-checklist-not-onboarding">
            This organization is {org.status}. Activation from Onboarding only applies while the organization is in the Onboarding status.
          </p>
        ) : requirements.ready_for_activation ? (
          <div className="flex flex-wrap items-center gap-4">
            <p className="text-sm font-semibold text-emerald-700 dark:text-emerald-400" data-testid="org-checklist-ready-message">All activation requirements are complete.</p>
            <button
              type="button"
              onClick={onActivate}
              disabled={activating}
              data-testid="org-activate-btn"
              className="inline-flex items-center gap-2 rounded-xl bg-emerald-600 px-5 py-2.5 text-sm font-bold text-white transition-colors duration-200 hover:bg-emerald-700 disabled:opacity-50"
            >
              {activating ? "Activating…" : "Activate Organization"}
            </button>
          </div>
        ) : (
          <p className="text-sm font-semibold text-amber-700 dark:text-amber-400" data-testid="org-checklist-blocked-message">
            {requirements.total_count - requirements.completed_count} requirement(s) remaining before this organization can be activated.
          </p>
        )}
      </Panel>
    </div>
  );
}
